import type { Component } from 'vue'

import type { NotificationData } from './types/notification'

export type NotificationClickResult = boolean | Promise<boolean>

export interface NotificationItemRenderer {
    /** Lower priority is checked first; defaults to 100. */
    priority?: number
    /** Returns true when this renderer should handle the given notification. */
    matches(notification: NotificationData): boolean
    /**
     * Optional fully-custom component used in place of the default row.
     * Receives prop `notification: NotificationData` and emits `markRead`/`delete`.
     */
    component?: Component
    /**
     * Optional click hook. Return `true` to consume the click and skip the
     * default `action_url` navigation.
     */
    onClick?(notification: NotificationData): NotificationClickResult
}

const renderers: NotificationItemRenderer[] = []

export function registerNotificationItemRenderer(renderer: NotificationItemRenderer): void {
    renderers.push(renderer)
    renderers.sort((a, b) => (a.priority ?? 100) - (b.priority ?? 100))
}

export function resolveNotificationItemRenderer(
    notification: NotificationData,
): NotificationItemRenderer | null {
    return renderers.find((r) => r.matches(notification)) ?? null
}

export function clearNotificationItemRenderers(): void {
    renderers.length = 0
}
